var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Cascader',{staticStyle:{"width":"300px"},attrs:{"data":_vm.data,"load-data":_vm.loadData},on:{"on-change":_vm.changeCascaderValue},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }